module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\">\n<path d=\"M53.3,6.8L23.8,36.3c-0.4,0.4-0.9,0.4-1.3,0L10.7,24.6c-0.4-0.4-0.9-0.4-1.3,0l-9.2,9.1c-0.4,0.4-0.4,0.9,0,1.3l22.1,22.1\n\tc0.4,0.4,0.9,0.4,1.3,0l40-39.9c0.4-0.4,0.4-0.9,0-1.3l-9.1-9.2C54.3,6.5,53.7,6.4,53.3,6.8C53.3,6.8,53.3,6.8,53.3,6.8z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/actions/checkmark.svg
// module id = 1386
// module chunks = 0